// extracted by mini-css-extract-plugin
export default {"profilesLabel":"profilesLabel---gSO6T","profilesPopoverContent":"profilesPopoverContent---6LSIp"};